import { FunctionComponent, HTMLAttributes } from 'react';

const IconCarDoor: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = ({
  title,
  ...props
}) => (
  <svg
    {...props}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.55381 0.452824C5.81625 0.164125 6.18511 0 6.57149 0H11.7505C12.5163 0 13.1371 0.632069 13.1371 1.41177V12.5882C13.1371 13.3679 12.5163 14 11.7505 14H2.27729C1.51146 14 0.890625 13.3679 0.890625 12.5882V6.23517C0.890625 5.87963 1.0224 5.53717 1.25961 5.27623L5.55381 0.452824ZM6.57149 1C6.4427 1 6.31975 1.05471 6.23226 1.15094L1.98268 5.99964L12.1371 5.99966V1.47059C12.1371 1.21069 11.9302 1 11.6749 1H6.57149ZM9.08433 7.875C8.86341 7.875 8.68433 8.05409 8.68433 8.275V9.00625C8.68433 9.22716 8.86341 9.40625 9.08433 9.40625H11.3507C11.5716 9.40625 11.7507 9.22716 11.7507 9.00625V8.275C11.7507 8.05409 11.5716 7.875 11.3507 7.875H9.08433Z"
      fill="#359AD2"
    />
  </svg>
);

export default IconCarDoor;
